<template>
  <ion-content>
    <div id="container" style="margin-left: 24px;margin-right: 24px;">
      <ion-row>
        <ion-col/>
        <ion-col/>
        <ion-col>
          <button 
            type="button" 
            @click="closeModal()" 
            style="margin-left: 67%;margin-top: 6px; border-radius: 10px;background: #000;"
          >
            <ion-icon :icon="closeOutline"></ion-icon> 
          </button>
        </ion-col>
      </ion-row>
      <ion-title> Agregar Compañia </ion-title>
      <ion-form>
        <ion-input type="text" id="nombre"  v-model="nombre"  placeholder="Ingrese el nombre de la Compañia" />
        
        <ion-row>
          <ion-col>
            <ion-label style="float: left;">Correo Designas </ion-label>
          </ion-col>
          <ion-col>
           
            <button 
              type="button" 
              @click="addCorreo('designas')" 
              style="float: right; border-radius: 10px;width: 30px; background: #000;"
            >
              +
            </button>
             <button 
              v-if="correo_designas.length > 1"
              type="button" 
              @click="minusCorreo('designas')" 
              style="float: right; border-radius: 10px;width: 30px; background: #000;"
            >
              -
            </button>
          </ion-col>
        </ion-row>
          
        <div v-for="(correo_d,key_d) in correo_designas" :key="key_d">
          <ion-input type="email" v-model="correo_designas[key_d]"  placeholder="Ingrese el correo de designa" />
        </div>

        <ion-row>
          <ion-col>
            <ion-label style="float: left;">Correo Minutas</ion-label>
          </ion-col>
          <ion-col>
            <button 
              type="button" 
              @click="addCorreo('minutas')" 
              style="float: right; border-radius: 10px;width: 30px; background: #000;"
            >
              +
            </button>
             <button 
              v-if="correo_minutas.length > 1"
              type="button" 
              @click="minusCorreo('minutas')" 
              style="float: right; border-radius: 10px;width: 30px; background: #000;"
            >
              -
            </button>

          </ion-col>
        </ion-row>
          
        <div v-for="(correo_m,key_m) in correo_minutas" :key="key_m">
          <ion-input type="email" v-model="correo_minutas[key_m]"  placeholder="Ingrese el correo de minuta" />
        </div>
        
        <ion-row>
          <ion-col>
            <ion-label style="float: left;">Correo Reclamaciones</ion-label>
          </ion-col>
          <ion-col>
           
            <button 
              type="button" 
              @click="addCorreo('reclamaciones')" 
              style="float: right; border-radius: 10px;width: 30px; background: #000;"
            >
              +
            </button>
             <button
              v-if="correo_reclamaciones.length > 1" 
              type="button" 
              @click="minusCorreo('reclamaciones')" 
              style="float: right; border-radius: 10px;width: 30px; background: #000;"
            >
              -
            </button>
          </ion-col>
        </ion-row>

        <div v-for="(correo_r,key_r) in correo_reclamaciones" :key="key_r">
          <ion-input type="email" v-model="correo_reclamaciones[key_r]"  placeholder="Ingrese el correo de reclamación" />
        </div>
        
        <ion-button color="dark" @click="postClinica">
          Enviar
        </ion-button>
      </ion-form>
    </div>
  </ion-content>
</template>

<script>

import { defineComponent } from 'vue';
import { closeOutline } from 'ionicons/icons';
import { modalController, IonInput } from '@ionic/vue';
import axios from 'axios'
import toast from '@/plugins/toast'

export default defineComponent({
  name: 'AgregarColaborador',
  components : { IonInput },
  setup() {
    return { closeOutline }
  },
  data() {
    return {
      nombre: '',
      correo_designas: [
        '' 
      ],
      correo_minutas: [
        ''
      ],
      correo_reclamaciones: [
        ''
      ]
    }
  },
  mounted(){
  
  },
  methods:{
    async closeModal() {
      const modal = await modalController
      return modal.dismiss();
    },
    async postClinica(){

      var loading = await toast.showLoading()

      await loading.present();

      axios.post('/api/companias',{
          nombre : this.nombre,
          correo_reclamaciones: this.correo_reclamaciones,
          correo_minutas: this.correo_minutas,
          correo_designas: this.correo_designas,
      })
      .then(data =>{
        loading.dismiss()
        this.closeModal()
        this.$toast.openToast("Registro de compania exitoso","success")
        console.log(data)
      }).catch(err =>{
        loading.dismiss()
        console.log(err)
      })
    },
    addCorreo(tipo){
      switch (tipo) {
        case "reclamaciones":
          this.correo_reclamaciones.push('')
          break;
        case "minutas":
          this.correo_minutas.push('')
          break;
        case "designas":
          this.correo_designas.push('')
          break;
        default:
          console.log("Lo lamentamos, por el momento no disponemos de " + tipo + ".");
      }
    },
    minusCorreo(tipo){
      switch (tipo) {
        case "reclamaciones":
          this.correo_reclamaciones.splice(this.correo_reclamaciones.length-1);
          break;
        case "minutas":
          this.correo_minutas.splice(this.correo_minutas.length-1)
          break;
        case "designas":
          this.correo_designas.splice(this.correo_designas.length-1)
          break;
        default:
          console.log("Lo lamentamos, por el momento no disponemos de " + tipo + ".");
      }
    }
  }
});
</script>

<style scoped>

ion-label {
  font-weight: bold;
}

ion-input {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

ion-button {
  width: auto;
  --border-radius: 5px;
  height: 35px;
  text-transform: none;
}
ion-textarea {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}
ion-select {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
  height: 50px;
}

.ion-sel-3-lbl{
  color: blue;
}
</style>
